import React, { useState,useEffect } from "react";
import Card from "./card";
import Parse from 'parse';
import swal  from 'sweetalert';
import Navbar from '../layouts/navbar';
// import styled from 'styled-components';
// import {Link} from 'react-router-dom';

// const StyledLink = styled.Link`
//   color:grey
// `
const Rehab = () => {

  const [rehabs, setRehabs] = useState([]);

  useEffect(() =>{
    var Rehab = Parse.Object.extend("Rehab");
    var query = new Parse.Query(Rehab);


    query.find()
    .then((rehabs) => {
      setRehabs(rehabs);
    },(error) => {
      console.log(error);
      swal("Oops!", "Seems like we couldn't load the rehabs..check your net connection please", "error");
    })
  }, []);



    return (
      <div>
        {/* <Header header='Rehab Center' /> */}
        <Navbar head="Rehab Centres" />
        <div style={{marginTop:"70px"}}>
        <div className='container-fluid my-3'>
        <div className='row justify-content-center'>
              
        {
          rehabs.map(rehab => (

            <div className='col-md-4 mb-3' key={rehab.id}>

              <Card  name={rehab.get("name")} email={rehab.get("email")} about={rehab.get("about")} location={rehab.get("location")} phno={rehab.get("phno")} link={rehab.id} />
            </div>
              
          ))
        }
       
        </div>
      </div>

        {/* <Card name="Rehab 2"/> */}
        </div>

        
      </div>
    );
  }

export default Rehab;
